class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-drawer-close]')) this.close();
    });
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    this.cartLink = cartLink;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.setAttribute('aria-controls', 'CartDrawer');
    cartLink.setAttribute('aria-expanded', 'false');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code !== 'Space') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (this.classList.contains('active') || this.classList.contains('is-opening')) return;

    this.classList.add('is-opening');
    this.cartLink?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');

    const dialog = this.querySelector('.drawer__inner');
    const focusTarget = this.querySelector('.cart-drawer__continue') || dialog;
    this.dialogTransitionEndHandler = (event) => {
      if (event.target !== dialog || event.propertyName !== 'transform') return;
      this.removeDialogTransitionEndHandler();
      if (this.classList.contains('active')) trapFocus(dialog, focusTarget);
    };
    dialog?.addEventListener('transitionend', this.dialogTransitionEndHandler);

    this.openAnimationFrame = requestAnimationFrame(() => {
      this.openAnimationFrame = requestAnimationFrame(() => {
        this.openAnimationFrame = null;
        if (!this.classList.contains('is-opening')) return;

        this.classList.add('active');
        this.classList.remove('is-opening');
      });
    });

    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    if (!this.classList.contains('active') && !this.classList.contains('is-opening')) return;

    if (this.openAnimationFrame) {
      cancelAnimationFrame(this.openAnimationFrame);
      this.openAnimationFrame = null;
    }
    this.removeDialogTransitionEndHandler();
    this.classList.remove('active', 'is-opening');
    this.cartLink?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    const focusTarget = this.activeElement?.isConnected ? this.activeElement : this.cartLink;
    removeTrapFocus(focusTarget);
  }

  removeDialogTransitionEndHandler() {
    if (!this.dialogTransitionEndHandler) return;
    this.querySelector('.drawer__inner')?.removeEventListener('transitionend', this.dialogTransitionEndHandler);
    this.dialogTransitionEndHandler = null;
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const sectionHTML = parsedState.sections?.[section.id];

      if (!sectionElement || !sectionHTML) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
    });

    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return section?.innerHTML || '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
